import { MfeLoad } from '@carvana/microfrontend';
import { useEffect } from 'react';
import { getMfeCacheBuster } from '@/common/MicroFrontEnds';
import { COMPOSER_MODULE } from '~/constants/common/MfeModules';
import { staticCdnUrl } from '~/constants/environment';
import { useMfeLoadStore } from '~/state/common/MfeLoadState';
import { generateErrorLogger } from '~/utilities/loggers';

export const logComposerError = generateErrorLogger('Composer UI MFE');

export default function useLoadComposerUiMfe() {
  const record = useMfeLoadStore(state => state.record);

  useEffect(() => {
    MfeLoad({
      files: [
        [
          COMPOSER_MODULE,
          [
            {
              component: 'default',
              default: {
                file: 'main.js',
                manifest: `${staticCdnUrl}/composer-ui/assets-manifest.json?v=${getMfeCacheBuster()}`
              }
            }
          ]
        ]
      ]
    }).catch(logComposerError);

    // Reset readiness on unmount so a stale value doesn't leak into the next mount.
    return () => {
      record({
        componentName: 'default',
        data: 'teardown',
        moduleName: COMPOSER_MODULE,
        timestamp: Date.now()
      });
    };
  }, [record]);
}
